import React, { useState, useRef, useEffect } from "react";
import Styles from "../../../assets/css/Blogs/PerfectGiftsGuide/SummerDress.module.css";
import { useGlobalState } from "../../../Functions/GlobalStates";
import debounce from "lodash.debounce";
import Loading from "../../Loadings/Loading";
import { Helmet } from "react-helmet-async";

const SummerDress = () => {
  // States Here
  const [IsLoaded, setIsLoaded] = useState(false); // I CAN use this to show loading before all images loads
  // Global States Here //////////////////////////////////////////////////////...............................
  const {
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    PagesWidthHeight,
    setPagesWidthHeight,
  } = useGlobalState();

  // React Elements References Here //////////////////////////////////// ...............
  const CheckPageStateRef = useRef(false); // Ref for the check Page
  const SummerDress = useRef(false); // Ref for the absolute box

  const ProductImages = require.context(
    "../../../assets/images/Blogs/PerfectGiftsGuide/SummerDress/Ai-Images",
    false,
    /\.(png|jpe?g|gif|bmp|webp|svg|avif)$/
  );
  const ProductImagesArray = [
    ProductImages("./19.avif"),
    ProductImages("./28.avif"),
    ProductImages("./29.avif"),
    ProductImages("./31.avif"),
    ProductImages("./32.avif"),
  ];

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {
      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  // Preload Images Before render it will help to descrease flickers on img change
  useEffect(() => {
    const preloadImages = async (imageArray, callback) => {
      try {
        await Promise.all(
          imageArray.map((src) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = src;
              img.onload = resolve;
              img.onerror = reject; // Add error handling
            });
          })
        );
        callback(); // Callback after all images are preloaded
      } catch (error) {
        console.error("Error preloading image:", error);
      }
    };

    preloadImages([ProductImagesArray[3]], () => {
      setIsLoaded(true); // Set state when all images are loaded
      // console.log("All Images Are Loaded");
    });
  }, []);

  // updating height to modify Navbar DropMenu height
  useEffect(() => {
    const updateSize = () => {
      if (SummerDress.current) {
        const { width, height } = SummerDress.current.getBoundingClientRect();
        setPagesWidthHeight((prev) => ({
          ...prev,
          height: parseFloat(height.toFixed(1)),
        }));
      }
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []); // Empty dependency array to run only on mount and unmount

  return IsLoaded ? (
    // Placeholder for position absoluted div that helps accupy the space of absoluted positioned div
    <>
      <Helmet>
        {/* Title Tag: Displayed in browser tabs and search results */}
        <title>Summer Dress – Stay Cool & Stylish ☀️</title>

        {/* Meta Description: A concise summary for search engines */}
        <meta
          name="description"
          content="Discover our latest collection of summer dresses. Perfect for beach days, picnics, and sunny adventures!"
        />

        {/* Meta Keywords: Helps with search engine indexing (use sparingly) */}
        <meta
          name="keywords"
          content="summer dress, stylish dresses, beachwear, casual outfits, summer fashion, women's clothing"
        />

        {/* Viewport: Ensures proper scaling on mobile devices */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Tags: Enhance social media sharing */}
        <meta
          property="og:title"
          content="Summer Dress – Stay Cool & Stylish ☀️"
        />
        <meta
          property="og:description"
          content="Discover our latest collection of summer dresses. Perfect for beach days, picnics, and sunny adventures!"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/PerfectGiftsGuide/summerdress"
        />
        {/* <meta property="og:image" content="/images/SummerDress/31.jpeg" /> */}

        {/* Twitter Card Tags: Enhance Twitter sharing with a large summary image */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Summer Dress – Stay Cool & Stylish ☀️"
        />
        <meta
          name="twitter:description"
          content="Discover our latest collection of summer dresses. Perfect for beach days, picnics, and sunny adventures!"
        />
        {/* <meta name="twitter:image" content="/images/SummerDress/31.jpeg" /> */}

        {/* Robots Tag: Instructs search engines to index this page and follow its links */}
        <meta name="robots" content="index, follow" />

        {/* Canonical Link: Prevents duplicate content issues by specifying the preferred URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/PerfectGiftsGuide/summerdress"
        /> */}

        {/* Additional SEO Optimization */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>

      <div ref={SummerDress} className={Styles.SummerDressContainer}>
        <section className={Styles.SummerDressSection1}>
          <div className={Styles.SummerDressSection1Text1Container}>
            {/* <h1>Powerful Compact Spotlight for Every Adventure 🌟</h1> */}
          </div>
          <img
            src={`${ProductImagesArray[3]}`}
            alt="Summer Dress"
            title="This is an AI-generated representation. Actual product may vary."
          />
          <p>
            These images are AI-generated representations of the products.
            Actual appearance, specifications, features, and colors may vary.
            For the most accurate and up-to-date product details, please refer
            to the official product page via the button at the end of this blog.
          </p>
          <div className={Styles.SummerDressSection1Text2Container}>
            <h1>| Summer Dress |</h1>
            <h1>The Ultimate Summer Dress Gift 🎁✨</h1>
            <p>
              Looking for a stylish and comfortable outfit for the warm season?
              This elegant summer dress is the perfect choice! Designed with a
              flattering fit and breathable fabric, it offers both fashion and
              ease. The adjustable spaghetti straps, flowy silhouette, and side
              slits ensure you stay cool while looking chic.
            </p>
          </div>
          <div className={Styles.SummerDressSection1Img2Container}>
            <img
              src={`${ProductImagesArray[2]}`}
              alt="Summer Dress"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[1]}`}
              alt="Summer Dress"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.SummerDressSection1Text3Container}>
            <h1>Why You’ll Love It 💖</h1>
            <p>
              <span style={{ color: "black" }}>Flattering Fit </span> ✅
              Designed to enhance your natural shape with a flowy, elegant cut.
            </p>
            <p>
              <span style={{ color: "black" }}>Lightweight & Breathable</span>{" "}
              ✅ Soft, stretchy fabric for all-day comfort.
            </p>
            <p>
              <span style={{ color: "black" }}>Versatile Style</span> ✅ Perfect
              for beach vacations, date nights, parties, and casual outings.
            </p>
            <p>
              <span style={{ color: "black" }}>Chic Details</span> ✅ Features a
              V-neckline, sleeveless design, and stylish side slits.
            </p>
            <p>
              <span style={{ color: "black" }}>
                Vibrant Prints & Solid Colors
              </span>{" "}
              ✅ A variety of patterns to match your unique style.
            </p>
            <p>
              <span style={{ color: "black" }}>Easy to Dress Up or Down</span>{" "}
              ✅ Pair with sandals, heels, or accessories for any occasion.
            </p>
          </div>
          <div className={Styles.SummerDressSection1Img3Container}>
            <img
              src={`${ProductImagesArray[4]}`}
              alt="Summer Dress"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[0]}`}
              alt="Summer Dress"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.SummerDressSection1Text4Container}>
            <h1>Perfect for Any Occasion 🌸</h1>
            <p>
              From tropical getaways to casual street looks, this dress is an
              essential addition to your summer wardrobe. Whether you’re
              attending a dinner, honeymoon trip, or a business-casual event,
              it’s designed to keep you stylish and comfortable all season long.
            </p>
          </div>
          <div className={Styles.SummerDressSection1Text5Container}>
            <h4>
              🔔 If you're interested, similar products are available through
              the provided sources.
            </h4>
          </div>
          <a
            title="This link leads to an affiliate product page. We may earn a commission at no extra cost to you."
            href="https://amzn.to/3EHp108"
            target="_blank"
            rel="noopener noreferrer"
            className={Styles.SummerDressSection1BtnAmazonAncherContainer}
          >
            <button
              title="This button leads to an affiliate product page. We may earn a commission at no extra cost to you."
              className={Styles.SummerDressSection1BtnAmazon}
            >
              Buy Now on <span>&nbsp;&nbsp;Amazon</span> <span>&nbsp;»</span>
            </button>
          </a>
          <div className={Styles.SummerDressSection1DesclaimerContainer}>
            <h1>Affiliate Disclaimer 💬</h1>
            <p>
              As an Amazon Associate, I earn from qualifying purchases. This
              helps support the blog at no extra cost to you.
            </p>
            <h1>AI-Generated Images Disclaimer</h1>
            <p>
              The product images on this site are AI-generated representations
              created for illustrative purposes only. They may not perfectly
              match the actual product in terms of color, design, or features.
              For accurate details and images, please refer to the official
              product listing on Amazon by clicking the provided links.
            </p>
            <h1>HashTags</h1>
            <p>
              #SummerFashion #CasualDresses #BeachStyle #BohoChic
              #VacationOutfits #TrendyLooks #WomenStyle #FashionTrends
              #ElegantWear #SpringOutfits
            </p>
            <h1>Keywords</h1>
            <p>
              Best summer dress for women 2025 Lightweight and breathable maxi
              dress Elegant sleeveless dress for vacation Flattering long dress
              with a flowy fit Trendy women’s fashion for casual outings Stylish
              outfit for beach vacations and dates Comfortable and chic dress
              for spring and summer
            </p>
          </div>
        </section>
      </div>
    </>
  ) : (
    <Loading />
  );
};

export default SummerDress;
